package one.healthium.profile.ui.avatar.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.composables.core.SheetDetent
import com.composables.core.SheetDetent.Companion.Hidden
import kotlinx.coroutines.launch
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppModalBottomSheet
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.components.AppTextButton
import one.healthium.ui.compose.components.rememberAppModalBottomSheetState
import one.healthium.ui.compose.theme.AppTheme

@Composable
internal fun ConfirmationSheet(
    title: String,
    message: String,
    positiveText: String,
    negativeText: String,
    onDismissed: () -> Unit,
    onPositiveClicked: () -> Unit,
    onNegativeClicked: () -> Unit,
) {
    val sheetState = rememberAppModalBottomSheetState(initialDetent = SheetDetent.FullyExpanded)
    val scope = rememberCoroutineScope()

    fun dismiss() {
        scope.launch { sheetState.animateTo(Hidden) }
    }

    AppModalBottomSheet(
        state = sheetState,
        onDismissed = onDismissed,

        ) {
        ConfirmationContent(
            title = title,
            message = message,
            positiveText = positiveText,
            negativeText = negativeText,
            onPositiveClicked = {
                dismiss()
                onPositiveClicked()
            },
            onNegativeClicked = {
                dismiss()
                onNegativeClicked()
            },
        )
    }
}

@Composable
private fun ConfirmationContent(
    title: String,
    message: String,
    positiveText: String,
    negativeText: String,
    onPositiveClicked: () -> Unit,
    onNegativeClicked: () -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .verticalScroll(rememberScrollState())
            .navigationBarsPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Spacer(Modifier.height(36.dp))
        AppText(
            modifier = Modifier.padding(horizontal = 32.dp),
            text = title,
            style = AppTheme.tutorialStyle?.titleStyle ?: AppTheme.textStyles.secondary_30_500,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(16.dp))
        AppText(
            modifier = Modifier.padding(horizontal = 32.dp),
            text = message,
            style = AppTheme.tutorialStyle?.messageStyle ?: AppTheme.textStyles.secondary_18_400,
            color = AppTheme.colors.text500,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(48.dp))
        AppButton(
            modifier = Modifier.defaultMinSize(minWidth = 176.dp),
            onClick = onPositiveClicked
        ) {
            Text(positiveText)
        }
        Spacer(Modifier.height(24.dp))
        AppTextButton(onClick = onNegativeClicked) {
            Text(negativeText)
        }
        Spacer(Modifier.height(50.dp))
    }
}